export const APP_VERSION = '0.1.1';
export const BUILD_DATE = '2026-07-22T14:57:11Z';
export const COMMIT_HASH = '2f2bc713';
export const BUILD_DATE_UTC = '2026-07-22T14:57:11Z';
export const BUILD_DATE_IST = '2026-07-22T20:27:11+05:30';
export const ENVIRONMENT = 'stage';
